import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FontWeights, mergeStyles, Text } from '@fluentui/react';
import { MicrosoftLogoIcon } from './MicrosoftLogoIcon';
/**
 * Microsoft logo with mark as SVG and tagline as text
 */
export const MicrosoftLogo = () => {
    return (_jsxs(_Fragment, { children: [_jsx(MicrosoftLogoIcon, {}), _jsx(Text, Object.assign({ className: mergeStyles({
                    '@media (min-width: 640px)': {
                        display: 'inline-block',
                    },
                }), styles: {
                    root: {
                        fontWeight: FontWeights.semibold,
                        alignSelf: 'center',
                        color: '#fff',
                        display: 'none',
                        padding: '0 14px 0 0',
                    },
                }, variant: 'mediumPlus' }, { children: "Microsoft" }))] }));
};
